import { groups, MetadataGroupType } from 'services/analytics/events';

interface TrackingData {
  name: string;
  type?: GroupType;
}

interface MemberTrackingData extends TrackingData {
  member: string;
}

const getGroupType = (groupType?: GroupType): MetadataGroupType => {
  switch (groupType) {
    case 'custom':
      return 'Custom';
    case 'other_people':
      return 'Other';
    case 'organization':
      return 'Organization';
    default:
      return 'Other';
  }
};

// Group Creation Tracking
export const trackingGroupCreateComplete = (data: TrackingData) => {
  return groups.create.complete({
    '[Group] Context': 'People Sidebar',
    '[Group] Name': data.name,
    '[Group] Type': getGroupType(data.type),
  });
};

export const trackingGroupCreateHover = () => {
  return groups.create.hover();
};

export const trackingGroupCreateClick = () => {
  return groups.create.click();
};

// Member Tracking
export const trackingGroupAddMemberClick = (data: TrackingData) => {
  return groups.members.add.click({
    '[Group] Context': 'People Sidebar',
    '[Group] Name': data.name,
    '[Group] Type': getGroupType(data.type),
  });
};

export const trackingGroupAddMemberComplete = (data: MemberTrackingData) => {
  return groups.members.add.complete({
    '[Group] Context': 'People Sidebar',
    '[Group] Name': data.name,
    '[Group] Type': getGroupType(data.type),
    '[Group] Member': data.member,
  });
};

export const trackingGroupAddMemberSearch = (data: TrackingData) => {
  return groups.members.add.search({
    '[Group] Context': 'People Sidebar',
    '[Group] Name': data.name,
    '[Group] Type': getGroupType(data.type),
  });
};

export const trackingGroupAddMemberSelectResult = (data: TrackingData) => {
  return groups.members.add.selectResult({
    '[Group] Context': 'People Sidebar',
    '[Group] Name': data.name,
    '[Group] Type': getGroupType(data.type),
  });
};

export const trackingGroupCollapse = (data: TrackingData) => {
  return groups.sidebar.collapse({
    '[Group] Context': 'People Sidebar',
    '[Group] Name': data.name,
    '[Group] Type': getGroupType(data.type),
  });
};

export const trackingGroupExpand = (data: TrackingData) => {
  return groups.sidebar.expand({
    '[Group] Context': 'People Sidebar',
    '[Group] Name': data.name,
    '[Group] Type': getGroupType(data.type),
  });
};

export const trackingGroupSelect = (data: TrackingData) => {
  return groups.sidebar.expand({
    '[Group] Context': 'People Sidebar',
    '[Group] Name': data.name,
    '[Group] Type': getGroupType(data.type),
  });
};

export const trackingGroupSelectMember = (data: MemberTrackingData) => {
  return groups.sidebar.selectMember({
    '[Group] Context': 'People Sidebar',
    '[Group] Name': data.name,
    '[Group] Type': getGroupType(data.type),
    '[Group] Member': data.member,
  });
};

// Group Early Access CTA Tracking
export const trackingGroupEarlyAccessRequest = () => {
  return groups.earlyAccess.click();
};
